import { useTLang } from 'intl/intl';

import type { SubstitutionFlowStatus } from 'shared/domain';

export function useSubstitutionFlowStatusAlertLang(props: Props) {
  const { status } = props;
  const langStrongAttention = useTLang({ id: 'substitutionFlow.033' });
  const label = {
    awaiting: {
      strong: useTLang({ id: 'substitutionFlow.031' }),
      sentence: useTLang({ id: 'substitutionFlow.032' }),
    },
    timeout: {
      strong: langStrongAttention,
      sentence: useTLang({ id: 'substitutionFlow.034' }),
    },
    another: {
      strong: langStrongAttention,
      sentence: useTLang({ id: 'substitutionFlow.035' }),
    },
    accepted: { strong: '', sentence: '' },
    refused: { strong: '', sentence: '' },
    chat: {
      strong: langStrongAttention,
      sentence: useTLang({ id: 'substitutionFlow.036' }),
    },
  };
  return {
    strong: label[status ?? 'accepted'].strong,
    sentence: label[status ?? 'accepted'].sentence,
  };
}

interface Props {
  status: SubstitutionFlowStatus | undefined;
}
